import React, {useState, useEffect} from 'react'
// Styles
import './otp.style.css'
// Constant
import { Base_API } from '../../_actions/matcher'
import { NhealthAction } from '../../_actions/action.api';
import BaseComponent from 'bootstrap/js/dist/base-component';
// Components
import Copyright from '../../components/Copyright';
// Alert
import Swal from 'sweetalert2';
import { useParams } from 'react-router-dom';
import { DecryptedOBJ, DecryptedText, EncryptedOBJ, EncryptedText } from '../../utils/Encryption';

function OTP(props) {
    const {fromPage} = useParams();    

    const [loading, setLoading] = useState(true);
    const [phoneNumber, setPhoneNumber] = useState('-');
    const [inputOTP, setInputOTP] = useState('');
    const [refOTP, setRefOTP] = useState('-');
    const [otpCount, setOTPCount] = useState(null);
    const [disabledResend, setDisabledResend] = useState(false);
    const [reqData, setReqData] = useState({
        "Firstname": '',
        "Lastname": '',
        "Birthday": '',
        "Phoneno": '',
        "Email": '',
        "line_display": '',
        "line_profile": '',
        "line_user": '',
        "line_token": '',
        "isinvite": '',
        "invite_line_user": '',
        'otp': '',
        'refotp': ''
    });

    useEffect(() => {
        dataInit();
    },[])

    // data init
    const dataInit = async() => {
        let getPhoneNumber = await checkFormData();
        await countDownOtpInit(getPhoneNumber);
        handleLoader('inactive');
    }

    const handleLoader = (status) => {
        if(status === 'active')
        {
            setLoading(true);
        }else
        {
            setLoading(false);
        }
    }

    const countDownOtpInit = async(phone) => {
        return new Promise(async resolve => {
            let countOTPStatus = localStorage.getItem('countdown-otp');
            let otpRef = !!localStorage.getItem('otpref') ? DecryptedText(localStorage.getItem('otpref')) : null;

            if(!!countOTPStatus)
            {
                await otpCountDown();
                if(!!otpRef)
                {
                    setRefOTP(otpRef);
                }
            }else
            {
                await otpCountDown();
                await handlerSendOTP(phone);
            }
            resolve();
        })
    }

    const showAlert = (msg) => {
        Swal.fire({
            title: "ผิดพลาด",
            text: msg,
            icon: 'error',
            confirmButtonText: 'ตกลง',
            customClass: {
                actions: 'my-actions',
                cancelButton: 'order-1 right-gap',
                confirmButton: 'order-2',
                denyButton: 'order-3',
            }        
        })
    }
    const showNoti = (msg, href) => {
        Swal.fire({
            allowOutsideClick: false,
            title: "แจ้งเตือน",
            text: msg,
            icon: 'success',
            confirmButtonText: 'ตกลง',
            customClass: {
                actions: 'my-actions',
                cancelButton: 'order-1 right-gap',
                confirmButton: 'order-2',
                denyButton: 'order-3',
            }        
        }).then((result) => {
            if (result.isConfirmed) {
                window.location.href = href;
            }
        })
    }

    const checkFormData = async() => {
        return new Promise(async resolve => {
            if(fromPage === 'register-card')
            {
                if(localStorage.getItem('form-register-card') !== null)
                {
                    let formData = !!localStorage.getItem('form-register-card') ? DecryptedOBJ(localStorage.getItem('form-register-card')) : null; 
                    let lineProfile = !!localStorage.getItem('line_profile') ? DecryptedOBJ(localStorage.getItem('line_profile')) : null;
                    let inviterCode = !!localStorage.getItem('invitercode') ? DecryptedText(localStorage.getItem('invitercode')) : null;

                    // console.log('Form Data:  ', formData);
                    // console.log('Line Profile: ', lineProfile);
                    // console.log('Input OTP: ', inputOTP);
                    // console.log('Ref OTP: ', refOTP);

                    setReqData({
                        Firstname: formData[0]["value"],
                        Lastname: formData[1]["value"],
                        Birthday: formData[2]["value"],
                        Phoneno: formData[3]["value"],
                        Email: formData[4]["value"],
                        line_display: lineProfile.display_name,
                        line_profile: lineProfile.picture_url,
                        line_user: lineProfile.user_id,
                        line_token: lineProfile.id_token,
                        isinvite: !!inviterCode ? true : false,
                        invite_line_user: !!inviterCode ? inviterCode : "",
                        otp: inputOTP,
                        refotp: refOTP
                    })
                    setPhoneNumber(formData[3].value);
                    resolve(formData[3].value);
                }else
                {
                    window.location.href = `${Base_API.pathWeb}/n-health/packages/ref`
                }
            }
        })
    }

    const handleChangeOTP = (e) => {
        let value = e.target.value;
        if(String(value).length <= 6)
        {
            setInputOTP(String(value).replace(/[^0-9.]/g, '').replace(/(\..*?)\..*/g, '$1'));
        }
    }

    const handleResendOTP = async() => {
        await otpCountDown();
        await handlerSendOTP(phoneNumber);
    }

    const handlerSendOTP = (phoneNumber) => {
        return new Promise(async resolve => {
            setDisabledResend(true);

            let formData = new FormData();
            formData.append('Phoneno', phoneNumber);
            NhealthAction.sendOTP(formData)
            .then(res => {
                if(res.isSuccess === true)
                {
                    // console.log('Sent OTP: ', res);
                    setRefOTP(res.errMessage);
                    localStorage.setItem('otpref', EncryptedText(res.errMessage));
                    resolve();
                }
            })
        })
    }

    const otpCountDown = async() => {
        return new Promise(async resolve => {
            let number = 120;
            localStorage.setItem('countdown-otp', true);
            let countDownOTP = setInterval(() => {
                if(number === 0)
                {
                    clearInterval(countDownOTP);
                    setOTPCount(null);
                    setDisabledResend(false);
                    localStorage.removeItem('countdown-otp');
                    return;
                }else
                {
                    number = number-1
                    setOTPCount(number);
                    setDisabledResend(true);
                }
            }, 1000)
            resolve();
        })
    }

    const handleSubmit = async() => {
        await verifyOTP()
        .then(() => {
            handleRegisMember();
        })

        // if(fromPage === 'register-card') 
        // {
        // }
    }

    const verifyOTP = () => {
        return new Promise(async resolve => {
            let formData = new FormData();
            formData.append('Phoneno', phoneNumber);
            formData.append('OTP', inputOTP);
            formData.append('refotp', refOTP);
            NhealthAction.verifyOTP(formData)
            .then(res => {
                if(res.isSuccess === true)
                {
                    localStorage.removeItem('countdown-otp');
                    localStorage.removeItem('otpref');
                    resolve();
                }else
                {
                    showAlert('OTP ไม่ถูกต้อง');
                }
            })
        }) 
    }

    const handleRegisMember = () => {
        // console.log('Req Data: ', reqData);

        let formData = {...reqData, otp: inputOTP, refotp: refOTP}

        NhealthAction.RegisMember(formData)
        .then(res => {
            if(res.isSuccess === true)
            {
                let memberData = EncryptedOBJ(res.member);
                localStorage.setItem('member_info', memberData);
                // clear
                localStorage.removeItem('countdown-otp');
                localStorage.removeItem('invitercode');

                let cameFromConfirmOrder = localStorage.getItem('cameFromConfirmOrder'); // ref
                if(!!cameFromConfirmOrder)
                {
                    let pathDest = cameFromConfirmOrder;
                    localStorage.setItem('cameFromRegistration', 'true'); // ให้หน้าสรุปการสั่งซื้อรู้ ว่าต้อง create cart ใหม่ เพราะ user ได้ทำการสมัครสมาชิกแล้ว
                    localStorage.removeItem('cameFromConfirmOrder');
                    let path = `${Base_API.pathWeb}${pathDest}`
                    showNoti(res.errMessage, path);
                }else
                {
                    let path = `${Base_API.pathWeb}/n-health/register-card/success`; 
                    showNoti(res.errMessage, path);
                }
            }else
            {
                showAlert(res.errMessage);
            }
            // console.log(res);
        })
        .catch(err => {
            showAlert('ไม่สามารถทำรายการได้ขณะนี้ กรุณาติดต่อเจ้าหน้าที่');
        })
    }

    return (
        <div className="otp-container">
            {/* card wrapper */}
            <div className="card-wrapper">
                {/* header text */}
                <h1 className="header-text t-blue">ยืนยันรหัส OTP SMS</h1>
                {/* otp title */}
                <p className="title">
                    ระบบได้ส่งเลข OTP 6 หลัก เพื่อยืนยันตัวตนผ่าน SMS ไปยังเบอร์ <span className="phone-number t-black">{phoneNumber}</span>
                </p>
                {/* input otp */}
                <input 
                    type="number" 
                    placeholder='กรอกรหัส OTP'
                    className="input" 
                    pattern='[0-9]*'
                    maxLength={6}
                    onChange={handleChangeOTP}
                    value={inputOTP}
                />
                {/* ref otp & resend otp */}
                <div className="ref-wrap">
                    <span className="ref t-lowblue">Ref. {refOTP}</span>
                    <span 
                        className="resend-otp"
                        onClick={disabledResend ? null : handleResendOTP}
                    >
                        {otpCount === null ? null : `(${otpCount} วินาที.)`} ส่งรหัส OTP อีกครั้ง
                    </span>
                </div>

                {/* submit button */}
                <button 
                    className="btn-submit"
                    onClick={handleSubmit}
                >
                    ยืนยันรหัส OTP 
                </button>
            </div>
            {/* Copyright */}
            <Copyright position={'fixed'} bgColor={'#F9FBFF'} />
        </div>
    )
}

export default OTP;